import * as React from "react";
import type { SVGProps } from "react";
const SvgFamily = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 8A2.51 2.51 0 0 1 2 5.62l-.06-1A2.53 2.53 0 0 1 4.45 2a2.56 2.56 0 0 1 2.63 2.53L7 5.62A2.51 2.51 0 0 1 4.5 8Zm.05-4a.56.56 0 0 0-.63.53l.06 1A.52.52 0 0 0 4.5 6a.52.52 0 0 0 .5-.49l.06-1A.53.53 0 0 0 4.55 4Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.293 21.707A1 1 0 0 0 21 21v-3h1a1 1 0 0 0 .86-.42 1 1 0 0 0 .14-.9l-2-5.87A2 2 0 0 0 19 9h-2a2 2 0 0 0-2 2 1 1 0 0 0 2 0h2c.002.108.019.216.05.32L20.61 16H20a1 1 0 0 0-1 1v4a1 1 0 0 0 .293.707ZM5.293 21.707A1 1 0 0 0 7 21v-4.59l.71-.7A1 1 0 0 0 8 15v-4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v4a1 1 0 0 0 .29.71l.71.7V21a1 1 0 1 0 2 0v-5a1 1 0 0 0-.29-.71l-.71-.7V11h3v3.59l-.71.7A1 1 0 0 0 5 16v5a1 1 0 0 0 .293.707Z"
    />
    <path
      fill="currentColor"
      d="M13.293 21.707A1 1 0 0 0 15 21v-2.59l.71-.7A1 1 0 0 0 16 17v-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2v3a1 1 0 0 0 .29.71l.71.7V21a1 1 0 0 0 2 0v-3a1 1 0 0 0-.29-.71l-.71-.7V14h3v2.59l-.71.7A1 1 0 0 0 13 18v3a1 1 0 0 0 .293.707Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 11A2.51 2.51 0 0 1 10 8.62l-.06-1A2.53 2.53 0 0 1 12.45 5a2.56 2.56 0 0 1 2.63 2.53L15 8.62A2.51 2.51 0 0 1 12.5 11Zm.05-4a.56.56 0 0 0-.63.53l.06 1a.52.52 0 0 0 .52.47.52.52 0 0 0 .5-.49l.06-1a.53.53 0 0 0-.51-.51ZM16.27 7.311A2.51 2.51 0 0 0 18 8a2.51 2.51 0 0 0 2.56-2.38l.07-1.09A2.559 2.559 0 0 0 18 2a2.53 2.53 0 0 0-2.57 2.62l.06 1a2.51 2.51 0 0 0 .78 1.691Zm1.551-3.293A.56.56 0 0 1 18.05 4a.53.53 0 0 1 .53.51l-.06 1a.52.52 0 0 1-.871.356.52.52 0 0 1-.169-.336l-.06-1a.559.559 0 0 1 .401-.512Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFamily;
